import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 px-3" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center space-y-3" data-id="element-64">
        <p className="font-display text-lg text-accent font-semibold" data-id="element-65">
          SALUD EN TU PLATO™
        </p>
        <p className="text-xs text-white/30" data-id="element-66">
          © Saludentuplato™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}